import { Outlet } from "@tanstack/react-router";
import { UpdateBanner } from "../components/UpdateBanner";

// Each screen draws its own frame (components/Shell.tsx); the receipt page (/r/) is full width.
export function RootLayout() {
  return (
    <>
      <UpdateBanner />
      <Outlet />
    </>
  );
}
